<div class="eone-tier-upgrade-dialog-plugin" hive-root>
    <div class="eone-tier-upgrade-dialog-plugin__header">
        <div class="eone-tier-upgrade-dialog-plugin__header-text">
            Upgrade from {{ renderInfo().currentLicenseTypeWithBandwidth }} to
            {{ renderInfo().recommendedLicenseTypeWithBandwidth }} - {{ renderInfo().targetName }}
        </div>
        @if (renderInfo().asOfTime) {
            <div class="eone-tier-upgrade-dialog-plugin__sub-header">
                Generated {{ renderInfo().asOfTime | date: 'mediumDate' }} — all data reflects this date
            </div>
        }
    </div>
    <div class="eone-tier-upgrade-dialog-plugin__body">
        <table class="eone-tier-upgrade-dialog-plugin__table">
            <thead>
                <tr>
                    <th></th>
                    <th>{{ renderInfo().currentLicenseType }} (Current)</th>
                    <th class="eone-tier-upgrade-dialog-plugin__recommended-col">
                        @if (renderInfo().recommendedTooltipText) {
                            <hive-info-icon
                                hiveTooltip
                                [hiveTooltipDescription]="renderInfo().recommendedTooltipText"
                            ></hive-info-icon>
                        }
                        {{ renderInfo().recommendedLicenseType }} (Recommended)
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (row of renderInfo().comparisonRows; track row.label) {
                    @if (row.subRows) {
                        @for (subRow of row.subRows; track $index) {
                            <tr>
                                @if ($first) {
                                    <td [attr.rowspan]="row.subRows.length">{{ row.label }}</td>
                                }
                                <td>{{ subRow.currentValue?.text }}</td>
                                <td>
                                    <span class="eone-tier-upgrade-dialog-plugin__improved">
                                        <hive-icon-component [icon]="faArrowUp" size="small" />
                                        {{ subRow.recommendedValue?.text }}
                                    </span>
                                </td>
                            </tr>
                        }
                    } @else {
                        <tr>
                            <td>{{ row.label }}</td>
                            <td>
                                @if (row.currentValue?.isWarning) {
                                    <span class="eone-tier-upgrade-dialog-plugin__warning">{{
                                        row.currentValue.text
                                    }}</span>
                                } @else {
                                    {{ row.currentValue?.text }}
                                }
                            </td>
                            <td>
                                <span class="eone-tier-upgrade-dialog-plugin__improved">
                                    <hive-icon-component
                                        [icon]="
                                            row.recommendedValue?.arrowDirection === 'down' ? faArrowDown : faArrowUp
                                        "
                                        size="small"
                                    />
                                    {{ row.recommendedValue?.text }}
                                </span>
                            </td>
                        </tr>
                    }
                }
            </tbody>
        </table>
        <div class="eone-tier-upgrade-dialog-plugin__chart">
            <div class="eone-tier-upgrade-dialog-plugin__chart-header">
                Projected load as % of SLA by tier
                <a hive-link (click)="toggleChart($event)">
                    @if (showChart()) {
                        Hide Chart
                    } @else {
                        Show Chart
                    }
                </a>
            </div>
            @if (showChart()) {
                <div #chartContainer class="eone-tier-upgrade-dialog-plugin__chart-container"></div>
                <div class="eone-tier-upgrade-dialog-plugin__chart-legend">
                    <div class="eone-tier-upgrade-dialog-plugin__chart-legend-row">
                        <span
                            class="eone-tier-upgrade-dialog-plugin__chart-legend-swatch"
                            [style]="legendSwatchStyles.currentHistorical"
                        ></span>
                        {{ renderInfo().currentLicenseType }} Historical Load (Current)
                    </div>
                    <div class="eone-tier-upgrade-dialog-plugin__chart-legend-row">
                        <span
                            class="eone-tier-upgrade-dialog-plugin__chart-legend-swatch"
                            [style]="legendSwatchStyles.currentProjected"
                        ></span>
                        {{ renderInfo().currentLicenseType }} Projected Load
                        @if (renderInfo().hasReserveIncrease) {
                            (after reserve increase)
                        } @else {
                            (Current)
                        }
                    </div>
                    <div class="eone-tier-upgrade-dialog-plugin__chart-legend-row">
                        <span
                            class="eone-tier-upgrade-dialog-plugin__chart-legend-swatch"
                            [style]="legendSwatchStyles.recommendedProjected"
                        ></span>
                        {{ renderInfo().recommendedLicenseType }} Projected Load (Recommended)
                    </div>
                </div>
            }
        </div>
    </div>
    <footer class="eone-tier-upgrade-dialog-plugin__footer">
        @if (renderInfo().allowDismiss) {
            <hive-button
                label="Dismiss Recommendation"
                emphasis="secondary"
                [disabled]="!renderInfo().allowDismiss() || renderInfo().actionInProgress()"
                hiveTooltip
                [hiveTooltipDescription]="renderInfo().allowDismiss() ? '' : 'Operation not permitted'"
                (click)="handleActionEvent(RecommendationActionEvent.DISMISS)"
            ></hive-button>
        }
        <hive-button
            label="Cancel"
            emphasis="secondary"
            [disabled]="renderInfo().actionInProgress()"
            (click)="handleActionEvent(RecommendationActionEvent.CANCEL)"
        ></hive-button>
        <hive-button
            label="Request Quote"
            emphasis="primary"
            [isLoading]="renderInfo().actionInProgress()"
            [disabled]="!renderInfo().allowRequestQuote() || renderInfo().actionInProgress()"
            hiveTooltip
            [hiveTooltipDescription]="renderInfo().allowRequestQuote() ? '' : 'Operation not permitted'"
            (click)="handleActionEvent(RecommendationActionEvent.REQUEST_QUOTE)"
        ></hive-button>
    </footer>
</div>
